<template>
  <div>
    <div class="download-app" v-if="url">
      <a href="javascript:" class="text-dark text-decoration-none">
        <div class="container-fluid p-0">
          <div class="row no-gutters">
            <div class="col-9 d-flex align-items-center" @click="instalar()">
              <div class="download-app__img mr-2">
                <img :src="base_assets + '/favicons/android-icon-192x192.png'" alt="Logo da empresa">
              </div>
              <div>
                <h6 class="font-weight-normal mb-0">Baixe nosso App</h6>
                <div class="small"><b class="text-primary">Instalar agora</b> </div>
              </div>
            </div>
            <div class="col-3 text-right">
              <button class="btn" @click.prevent="close()">
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path d="M27.1 1.1c-10.4 2-19.4 9.1-23.9 18.7C1 24.5.5 26.9.5 33.5c0 15.5-6.8 7.8 107.5 122l101 101-101.9 102C24.4 441.4 4.9 461.4 3 465.5c-3.4 7.1-3.5 19.9-.2 27 2.9 6.3 9.3 12.9 15.7 16.3 7.2 3.7 18.7 4.2 27 1.2 5.8-2.2 9.4-5.6 108.3-104.4L256 303.5l101.8 101.6c81.7 81.6 102.7 102.1 106.7 104 4.2 2 6.5 2.4 14.5 2.4 8.3 0 10.1-.4 14.5-2.7 6.2-3.2 12.9-10.3 15.8-16.6 3.2-6.8 3-19.7-.3-26.7-1.9-4.1-21.4-24.1-104.1-107L303 256.5l101-101C518.3 41.3 511.5 49 511.5 33.5c0-6.5-.5-9-2.6-13.5-8.1-17.2-28.4-24.2-45.4-15.8-2.6 1.3-39.1 37-105.7 103.6L256 209.5 154.3 107.8C87.6 41.2 51.1 5.5 48.5 4.2 45.1 2.5 34-.3 32.1.1c-.3.1-2.6.5-5 1"/></svg>
              </button>
            </div>
          </div>
        </div>
      </a>
    </div>
    <modal-bottom :opened="modalDownload" v-if="modalDownload">
      <div class="container-fluid">
        <button class="btn btn-sm btn-close" @click="close()">
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512"><path d="M27.1 1.1c-10.4 2-19.4 9.1-23.9 18.7C1 24.5.5 26.9.5 33.5c0 15.5-6.8 7.8 107.5 122l101 101-101.9 102C24.4 441.4 4.9 461.4 3 465.5c-3.4 7.1-3.5 19.9-.2 27 2.9 6.3 9.3 12.9 15.7 16.3 7.2 3.7 18.7 4.2 27 1.2 5.8-2.2 9.4-5.6 108.3-104.4L256 303.5l101.8 101.6c81.7 81.6 102.7 102.1 106.7 104 4.2 2 6.5 2.4 14.5 2.4 8.3 0 10.1-.4 14.5-2.7 6.2-3.2 12.9-10.3 15.8-16.6 3.2-6.8 3-19.7-.3-26.7-1.9-4.1-21.4-24.1-104.1-107L303 256.5l101-101C518.3 41.3 511.5 49 511.5 33.5c0-6.5-.5-9-2.6-13.5-8.1-17.2-28.4-24.2-45.4-15.8-2.6 1.3-39.1 37-105.7 103.6L256 209.5 154.3 107.8C87.6 41.2 51.1 5.5 48.5 4.2 45.1 2.5 34-.3 32.1.1c-.3.1-2.6.5-5 1"/></svg>
        </button>
        <div class="download-app__img mx-auto mt-2" style="width: 72px; margin-bottom: 24px">
          <img :src="base_assets + '/favicons/android-icon-192x192.png'" alt="Logo da empresa">
        </div>
        <p>
          Instale o App e garanta ainda mais rapidez no seu próximo pedido.
        </p>
        <div v-if="isIOS">
          <p class="ios-app">
            1. Clique em <b>Opções</b> no Safari<img src="../assets/infoSafari2.png" style="width: 22px; margin-left: 3px; vertical-align: middle" alt="Opções do Safari"><br>
            2. Selecione <b>Compartilhar</b><br>
            3. Toque em <b>Ver Mais</b><br>
            4. Escolha <b>Adicionar à Tela de Início</b>
          </p>
        </div>
        <div v-else>
          Clique nos três pontinhos do canto superior direito e depois em <b>“Adicionar à tela inicial”.</b>
          <button class="btn btn-block mt-3 text-primary" @click="close()">Agora não</button>
        </div>
      </div>
    </modal-bottom>
  </div>
</template>

<script>
  import ModalBottom from "./ModalBottom";
  export default {
    name: "DownloadApp",
    components: {ModalBottom},
    data() {
      return {
        url: null,
        app_ios: false,
        app_android: false,
        modalDownload: false
      }
    },

    methods: {
      close() {
        this.url = null;
        sessionStorage.setItem('closeApp', '1');
        document.body.classList.remove("modal-open");
        this.modalDownload = false;
      },

      instalar() {
        const url = this.url;
        this.url = null;

        if (url === 'pwa') {
          if (this.isAndroid && this.prompt) {
            this.prompt.prompt();

          } else {
            document.body.classList.add("modal-open");
            this.modalDownload = true;
          }

        } else if (url) {
          window.open(url, '_blank');
        }
      }
    },

    mounted() {
      if (sessionStorage.getItem('closeApp')) {
        return;
      }

      if (this.ios_installed || this.android_installed || this.isInstagram) {
        return;
      }

      if (window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
        return;
      }

      if (this.isIOS && this.envEmpresa.VUE_APP_IOS_APP) {
        this.url = 'https://apps.apple.com/br/app/' + this.envEmpresa.VUE_APP_IOS_APP;
        return;

      } else if (this.isAndroid && this.envEmpresa.VUE_APP_ANDROID && this.envEmpresa.VUE_APP_ANDROID_PACKAGE_NAME) {
        this.url = 'https://play.google.com/store/apps/details?id=' + this.envEmpresa.VUE_APP_ANDROID_PACKAGE_NAME;
        return;
      }

      const isSafari = this.isIOS && /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(navigator.userAgent);

      if (isSafari || (this.isAndroid && this.prompt)) {
        this.url = 'pwa';
      }
    },

    computed: {
      prompt() {
        return this.$store.state.pwaPrompt;
      }
    }
  }
</script>

<style scoped>
  .download-app {
    padding: 15px 8px 15px 15px;
    background-color: #ffffff;
  }

  .download-app__img {
    width: 40px;
  }

  .download-app__img img {
    width: 100%;
    border-radius: 4px;
  }

  .btn-close {
    position: absolute;
    right: 15px;
  }

  @media (min-width: 768px) {
    .download-app {
      margin: 0 15px 8px;
      border-radius: 18px;
      box-shadow: var(--shadow);
    }
  }
</style>
